export default (root: string) => {
    const specificRoot = `${root}/dashboard`;
    return {
            root: specificRoot,
            configure: `${specificRoot}/configure`
    };
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/dashboard/DashboardOverview/dashboardRouteLinks.ts